/**
 * `msg_type` values for websocket control frames that carry no order/RFQ
 * payload: a connection acknowledgement (`success` on the order stream,
 * `connected` on the RFQ stream) or the server liveness `heartbeat`.
 */
export const CONTROL_MSG_TYPES = new Set(['heartbeat', 'success', 'connected'])

/**
 * Returns true when a parsed websocket message is a control frame rather than a
 * data event. Blotter message handlers must short-circuit on these before
 * dereferencing `event` or advancing the HWM — e.g. the RFQ handler would
 * otherwise throw reading `event.rfq_id` on an `event`-less heartbeat.
 */
export function isControlMessage(
  message: { msg_type?: string } | null | undefined,
): boolean {
  return message != null && CONTROL_MSG_TYPES.has(message.msg_type ?? '')
}
